import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const SolidCaretDown = ({ color = colors.gray[600], ...props }: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9.75C18 9.33 17.67 9 17.25 9H6.75C6.33 9 6 9.33 6 9.75C6 9.945 6.075 10.11 6.195 10.245L11.445 16.245C11.58 16.395 11.775 16.5 12 16.5C12.225 16.5 12.42 16.395 12.555 16.245L17.805 10.245C17.925 10.11 18 9.945 18 9.75Z"
      fill={color}
    />
  </svg>
);

export default SolidCaretDown;
